import React, { useEffect, useState, useRef } from 'react';
import { FiMenu } from 'react-icons/fi';
import LogoHeader from './LogoHeader';
import NavBar from './NavBar';
import './Header.css';

const MOBILE_BREAKPOINT = 1110; // px

const Header = () => {
  const [showHeader, setShowHeader] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  // Responsive
  const [isCompact, setIsCompact] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= MOBILE_BREAKPOINT : false
  );
  const [drawerOpen, setDrawerOpen] = useState(false);
  const lastScrollYRef = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY && currentScrollY > 550) {
        setShowHeader(false);
      } else {
        setShowHeader(true);
      }
      setLastScrollY(currentScrollY);
      lastScrollYRef.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  // Detectar ancho para activar/desactivar modo compacto
  useEffect(() => {
    const onResize = () => {
      const compact = window.innerWidth <= MOBILE_BREAKPOINT;
      setIsCompact(compact);
      if (!compact) setDrawerOpen(false);
    };
    window.addEventListener('resize', onResize, { passive: true });
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // Bloquear scroll de fondo cuando el drawer está abierto
  useEffect(() => {
    const cls = 'no-scroll';
    if (isCompact && drawerOpen) document.documentElement.classList.add(cls);
    else document.documentElement.classList.remove(cls);
    return () => document.documentElement.classList.remove(cls);
  }, [isCompact, drawerOpen]);

  return (
    <header className={`main-header ${showHeader ? 'visible' : 'hidden'}`}>
      <LogoHeader />

      {/* Desktop: NavBar como siempre; Compacto: NavBar renderiza drawer interno */}
      <NavBar
        mode={isCompact ? 'compact' : 'desktop'}
        drawerOpen={drawerOpen}
        closeDrawer={() => setDrawerOpen(false)}
      />

      {/* Botón de menú a la DERECHA (solo en compacto) — tamaño de ícono aumentado */}
      {isCompact && (
        <button
          type="button"
          className={`fi-menu-right ${drawerOpen ? 'open' : ''}`}
          aria-label={drawerOpen ? 'Cerrar menú' : 'Abrir menú'}
          aria-expanded={drawerOpen}
          aria-controls="mobile-drawer"
          onClick={() => setDrawerOpen((v) => !v)}
        >
          <FiMenu size={30} />
        </button>
      )}
    </header>
  );
};

export default Header;
